import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'

import './CertificateSettingsFormModal.scss'
import { ICertificateSettings } from 'app_types/admin/certificateSettings/certificateSettings.types';
import CertificateSettingsForm from '../CertificateSettingsForm/CertificateSettingsForm';
import { ICourseSchedulingDetailListItem } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes';
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes';

interface ICertificateSettingsFormModalProps {
  onClose: (saved?: boolean) => void
  open: boolean
  editData?: ICertificateSettings
  courseSchedulingDetails: ICourseSchedulingDetailListItem[]
  courseScheduling: ICourseSchedulingListItem
}

const CertificateSettingsFormModal: FC<ICertificateSettingsFormModalProps> = ({
  onClose,
  open,
  editData,
  courseSchedulingDetails,
  courseScheduling,
}) => {

  const handleCloseModal = () => {
    onClose()
  }

  return (
    <Modal
      show={open}
      onHide={handleCloseModal}
      size='lg'
    >
      <Modal.Header>
        <Modal.Title>
          {!!editData ? 'Editar certificado' : 'Crear certificado'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="certificate-settings-form-modal--layout">
          <CertificateSettingsForm
            courseSchedulingDetails={courseSchedulingDetails}
            editData={editData}
            onCancel={onClose}
            onSaved={() => onClose(true)}
            courseScheduling={courseScheduling}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default CertificateSettingsFormModal
